import React from 'react';
import ReactDOM from 'react-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-daterangepicker/daterangepicker.css';
import 'react-widgets/dist/css/react-widgets.css';
import "react-datepicker/dist/react-datepicker.css";
import './assets/scss/style.scss';
import * as serviceWorker from './serviceWorker';
import { BrowserRouter as Router, Link, Route, Switch } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import PrivateRoute from "./auth/components/PrivateRoute";
import 'react-toastify/dist/ReactToastify.css';
import Login from "./views/Login";
import axios from "axios"

import PaList from "./views/partner/List";
import PaDetail from "./views/partner/Details";

import RList from "./views/rider/List";
import RDetail from "./views/rider/Details";

import COList from "./views/customerOrder/customerOrderList";
import CODetails from "./views/customerOrder/customerOrderDetails";

// import ReturnOrderList from "./views/returnOrder/List";
// import ReturnOrderDetails from "./views/returnOrder/Details";

// Return Order
import ROrderList from "./views/aggReturnOrder/List";
import ROPDetails from "./views/aggReturnOrder/Partner";
import ROCDetails from "./views/aggReturnOrder/Customer";

import RouList from "./views/route/List";
import RouDetail from "./views/route/Details";

import Reconciliation from "./views/reconciliation/Reconciliation";
import RouteCollect from "./views/reconciliation/CollectFromRoute";
import RiderCollect from "./views/reconciliation/CollectFromRider";

import RAList from "./views/ra/List";
import RADetail from "./views/ra/Details";
import Dashboard from "./views/Dashboard";

import SRMarginList from "./views/srMargin/List"
import SRMarginDetails from "./views/srMargin/Details"
import PartnerCommission from './views/srMargin/PartnerCommissionDetails';

import CashDeposit from './views/cashDeposit/DepositForm'
import DepositList from "./views/cashDeposit/List";
import DepositDetails from "./views/cashDeposit/Details";

import CTList from "./views/commissionTransactions/List"
import CTDetails from "./views/commissionTransactions/Details"

import PartnerMargin from './views/reports/partnerMargin'

import BackwardChallanList from './views/challan/BackwardChallanList';
import BackwardChallanDetail from './views/challan/BackwardChallanDetail';
import ForwardChallanList from './views/challan/ForwardChallanList'
import ForwardChallanDetail from './views/challan/ForwardChallanDetails'

import { Provider } from "react-redux";
import store from "./redux/store";
import { getLocalAuthToken } from "./helper/utils";

import { toast } from "react-toastify";
import BackwardChallanForm from './views/challan/BackwardChallanForm';

const authToken = getLocalAuthToken() ? getLocalAuthToken()?.token : '';
const authData = getLocalAuthToken();

axios.defaults.headers.common['Authorization'] = authToken || ''
axios.interceptors.response.use((response) => {
    return response;
}, (error) => {
    if (error?.response?.status === 401) {
        localStorage.clear()
        window.location.replace("/login")
    } else if (error?.response?.status === 500) {
        toast.error("Something went wrong, please try again. If problem persist, please contact system admin.")
    } else {
        return error.response;
    }
})

ReactDOM.render(
    <Provider store={store}>
        <Router>
            <Switch>

                <PrivateRoute exact path="/">
                    <Dashboard />
                </PrivateRoute>

                <Route exact path="/login">
                    <Login />
                </Route>
                
                <PrivateRoute exact path="/partner/list">
                    <PaList />
                </PrivateRoute>

                <PrivateRoute exact path="/partner/details/:id">
                    <PaDetail />
                </PrivateRoute>
                
                <PrivateRoute exact path="/rider/list">
                    <RList />
                </PrivateRoute>

                <PrivateRoute exact path="/rider/details/:id">
                    <RDetail />
                </PrivateRoute>

                <PrivateRoute exact path="/customerOrder/list">
                    <COList />
                </PrivateRoute>

                <PrivateRoute exact path="/customerOrder/details/:id">
                    <CODetails />
                </PrivateRoute>

                {/* <PrivateRoute exact path="/return-order/list">
                    <ReturnOrderList/>
                </PrivateRoute>

                <PrivateRoute exact path="/return-order/details/:id">
                    <ReturnOrderDetails/>
                </PrivateRoute> */}

                <PrivateRoute exact path="/agg-return-order/partners/details/:id">
                    <ROPDetails />
                </PrivateRoute>

                <PrivateRoute exact path="/agg-return-order/customers/details/:id">
                    <ROCDetails />
                </PrivateRoute>

                <PrivateRoute exact path="/agg-return-order/list">
                    <ROrderList />
                </PrivateRoute>

                <PrivateRoute exact path="/ra/list">
                    <RAList />
                </PrivateRoute>

                <PrivateRoute exact path="/ra/details/:id">
                    <RADetail />
                </PrivateRoute>

                <PrivateRoute exact path="/route/list">
                    <RouList />
                </PrivateRoute>

                <PrivateRoute exact path="/route/details/:id">
                    <RouDetail />
                </PrivateRoute>

                <PrivateRoute exact path="/route/collect/:id">
                    <RouteCollect />
                </PrivateRoute>

                <PrivateRoute exact path="/rider/collect/:id">
                    <RiderCollect />
                </PrivateRoute>

                <PrivateRoute exact path="/reconciliation">
                    <Reconciliation />
                </PrivateRoute>

                <PrivateRoute exact path="/srMargin/list">
                    <SRMarginList />
                </PrivateRoute>

                <PrivateRoute exact path="/srMargin/details/:id">
                    <SRMarginDetails />
                </PrivateRoute>

                <PrivateRoute exact path="/partner-commission-details/:id">
                    <PartnerCommission />
                </PrivateRoute>

                <PrivateRoute exact path="/cash-deposit">
                    <CashDeposit />
                </PrivateRoute>

                <PrivateRoute exact path="/cash-deposit/list">
                    <DepositList />
                </PrivateRoute>

                <PrivateRoute exact path="/cash-deposit/details/:id">
                    <DepositDetails />
                </PrivateRoute>

                <PrivateRoute exact path="/commission-transactions/list">
                    <CTList />
                </PrivateRoute>

                <PrivateRoute exact path="/commission-transactions/details/:id">
                    <CTDetails />
                </PrivateRoute>

                <PrivateRoute exact path="/partner-margin">
                    <PartnerMargin/>
                </PrivateRoute>

                <PrivateRoute exact path="/challan/list">
                    <ForwardChallanList/>
                </PrivateRoute>

                <PrivateRoute exact path="/challan/details/:id">
                    <ForwardChallanDetail/>
                </PrivateRoute>

                <PrivateRoute exact path="/return-challan/list">
                    <BackwardChallanList/>
                </PrivateRoute>

                <PrivateRoute exact path='/return-challan/create'>
                    <BackwardChallanForm/>
                </PrivateRoute>

                <PrivateRoute exact path="/return-challan/details/:id">
                    <BackwardChallanDetail/>
                </PrivateRoute>

                <Route>
                    <p>404 | Page not found</p>
                    <p><Link to="/">Back to Home</Link></p>
                </Route>

            </Switch>
        </Router>

        <ToastContainer position="bottom-right" autoClose={3000} />
    </Provider>
    , document.getElementById('root'));

serviceWorker.unregister();
